import { isPossibleNumber } from "./phone";

const ZOOM_URL_REGEX =
  /((https|zoom):\/\/([^/]*\.)?)?(zoom|zoomgov)\.(us|com)\/(u|j|my)\/[^\s,&<>]*/g;
const MEET_URL_REGEX = /((https):\/\/)?meet\.google\.com\/[^\s,&]*/g;
const TEAMS_URL_REGEX =
  /(https:\/\/)?teams\.microsoft\.com\/l\/meetup-join\/[^\s,&]*/g;
const CODERPAD_URL_REGEX = /((https):\/\/)([^/]*\.)?coderpad\.io\/[^\s,&]*/g;
const CODESIGNAL_URL_REGEX =
  /((https):\/\/)([^/]*\.)?codesignal\.com\/[^\s,&]*/g;

export enum ConferenceServiceEnum {
  Zoom,
  Meet,
  Teams,
  Codesignal,
  Coderpad,
  Phone,
}

export function labelForConferenceService(type: ConferenceServiceEnum): string {
  switch (type) {
    case ConferenceServiceEnum.Zoom:
      return "Zoom";
    case ConferenceServiceEnum.Meet:
      return "Meet";
    case ConferenceServiceEnum.Teams:
      return "Teams";
    case ConferenceServiceEnum.Codesignal:
      return "CodeSignal";
    case ConferenceServiceEnum.Coderpad:
      return "CoderPad";
    case ConferenceServiceEnum.Phone:
      return "Phone";
    default:
      throw new Error("Unknown conference service type");
  }
}

/**
 * Try to match a conference url ANYWHERE in the passed in string.
 */
function parseConferenceUrl(
  potentialUrl: string | null,
  service: ConferenceServiceEnum
): string | null {
  if (!potentialUrl) {
    return null;
  }

  let regex;
  switch (service) {
    case ConferenceServiceEnum.Zoom:
      regex = ZOOM_URL_REGEX;
      break;
    case ConferenceServiceEnum.Meet:
      regex = MEET_URL_REGEX;
      break;
    case ConferenceServiceEnum.Teams:
      regex = TEAMS_URL_REGEX;
      break;
    case ConferenceServiceEnum.Coderpad:
      regex = CODERPAD_URL_REGEX;
      break;
    case ConferenceServiceEnum.Codesignal:
      regex = CODESIGNAL_URL_REGEX;
      break;
    default:
      throw new Error(`No matching service supported for ${service}`);
  }

  const matches = potentialUrl.match(regex);

  return matches?.[0] || null;
}

export function conferenceUrlType(
  test: string | null
): ConferenceServiceEnum | undefined {
  let result;
  [
    ConferenceServiceEnum.Zoom,
    ConferenceServiceEnum.Meet,
    ConferenceServiceEnum.Teams,
    ConferenceServiceEnum.Codesignal,
    ConferenceServiceEnum.Coderpad,
  ].forEach((service) => {
    if (parseConferenceUrl(test, service)) {
      result = service;
    }
  });

  /**
   * If we found a result, let's return it. The phone number test can misinterpret a
   * conference link for a phone number, which would override this result.
   * e.g. https://guide-co.zoom.us/j/5558675309 => (555) 867-5309
   */
  if (result !== undefined) {
    return result;
  }

  if (isPossibleNumber(test)) {
    result = ConferenceServiceEnum.Phone;
  }

  return result;
}

export default parseConferenceUrl;
